import { PartnerActionTypes, TPartnerData } from '@types';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useAppDispatch } from '@/store';
import partnersList from '../partner.data';
import { setRefData } from '../redux/partner.actions';

const usePartnerData = (partner: Omit<TPartnerData, 'extraData'>, miyo, pageDesign) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!partner?.partner?.id) return;

    const p = partnersList[partner.partner.id] || {};

    if (p) {
      const partnerFull: TPartnerData = {
        ...partner,
        ...p,
      };
      dispatch({
        type: PartnerActionTypes.SET_PARTNER_DATA,
        payload: partnerFull,
      });
    }
  }, [partner]);

  useEffect(() => {
    if (!miyo) return;

    dispatch(setRefData(miyo));
  }, [miyo]);

  useEffect(() => {
    if (!pageDesign) return;

    dispatch({
      type: PartnerActionTypes.SET_PAGE_DESIGN,
      payload: pageDesign,
    });
  }, [pageDesign]);
};

export default usePartnerData;
